jQuery(document).ready(function($){
    if ( $('.nf-testimonial-slider-block') ) {
        $('.nf-testimonial-slider-block .nf-testimonial-slider-block__wrapper').slick({
            slidesToScroll: 1,
            slidesToShow: 1,
            prevArrow: '',
            nextArrow: '<button><svg width="63" height="45" viewBox="0 0 63 45" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M62.1213 24.6213C63.2929 23.4497 63.2929 21.5502 62.1213 20.3787L43.0294 1.28679C41.8579 0.11522 39.9584 0.11522 38.7868 1.28679C37.6152 2.45837 37.6152 4.35786 38.7868 5.52943L55.7574 22.5L38.7868 39.4706C37.6152 40.6421 37.6152 42.5416 38.7868 43.7132C39.9584 44.8848 41.8579 44.8848 43.0294 43.7132L62.1213 24.6213ZM2.62268e-07 25.5L60 25.5L60 19.5L-2.62268e-07 19.5L2.62268e-07 25.5Z" fill="white"/></svg></button>',
            appendArrows: $('.nf-testimonial-slider-block__nav'),
            appendDots: $('.nf-testimonial-slider-block__nav'),
            dots: true,
        });
    }
});